import { Injectable } from '@angular/core';
import { MatDateFormats } from '@angular/material/core';

const EN_DATE_FORMAT: MatDateFormats = {
  parse: {
    dateInput: 'MM/DD/YYYY',
  },
  display: {
    dateInput: 'MMMM DD, YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

const FR_DATE_FORMAT: MatDateFormats = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD MMMM YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Injectable({ providedIn: 'root' })
export class MpsDateFormatService {
  private readonly formats: MatDateFormats = {
    parse: { ...EN_DATE_FORMAT.parse },
    display: { ...EN_DATE_FORMAT.display },
  };

  public get currentFormats(): MatDateFormats {
    return this.formats;
  }

  public setLocale(locale: string | null | undefined): void {
    const normalized = (locale || '').toLowerCase();
    const next = normalized.startsWith('fr') ? FR_DATE_FORMAT : EN_DATE_FORMAT;

    this.formats.parse = { ...next.parse };
    this.formats.display = { ...next.display };
  }
}
